import React from 'react';
import './Enterprise.css'; // CSS file
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TrainingSection from './TrainingSection';
import ProcedureSection from './ProcedureSection';
import AdmissionButtonSection from './AdmissionButtonSection';
import SchoolMeetingSection from './SchoolMeetingSection';

import topImageFeature from '../assets/images/enterprise/enterprise-image-top-01.jpeg'; // Adjust the image path accordingly
import ContactButtonSection from './ContactButtonSection';

const Enterprise = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [hash]);

  return (
    <div className="feature-page">
      <div className="page-title">
        <h1>法人向けコンテンツ</h1>
        <p>Enterprise</p>
      </div>
      <div className="learning-image-container">
        <img src={topImageFeature} alt="Enterprise" className="top-image" />
      </div>

      <section id="training-section">
        <TrainingSection />
      </section>

      <section id='contact-button-section'>
        <ContactButtonSection />
      </section>
      
    </div>
  );
};

export default Enterprise;